import { render, staticRenderFns } from "./sales-by-product-type.vue?vue&type=template&id=d7d44420&scoped=true&"
import script from "./sales-by-product-type.vue?vue&type=script&lang=js&"
export * from "./sales-by-product-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d44420",
  null
  
)

export default component.exports